function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from 'firebase/app';
import tasks from '@/js/tasks';
import 'firebase/auth';
import { mapMutations } from 'vuex';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import { GA_EVENTS } from '@/js/constants';
import user_access_service from '@/services/user_access_service';

// firebase.initializeApp(firebaseConfig)
var provider = new firebase.auth.GoogleAuthProvider();
export default {
  name: 'AuthPage',
  data: function data() {
    return {
      // sign in buttons
      isLoading: false,
      isSignInDisabled: false,
      // form
      isFormValid: true,
      email: '',
      password: '',
      // form error
      error: false,
      errorMessages: '',
      errorProvider: false,
      errorProviderMessages: '',
      // show password field
      showPassword: false,
      current_provider: 'google',
      providers: [{
        id: 'google',
        label: 'Sign in with Google',
        isLoading: false
      }, {
        id: 'microsoft',
        label: 'Sign in with Office 365',
        isLoading: false
      }],
      test_pri: [{
        id: 'email',
        label: 'Sign in with Email',
        isLoading: false
      }],
      companies: [{
        id: 'otros',
        text: 'Otras Empresas del Grupo Intercorp'
      }, {
        id: 'inlearning.pe',
        text: 'In Learning'
      }],
      current_company: 'otros'
    };
  },
  created: function created() {
    /* if (window.userInfo && window.userInfo.email) {// && window.userInfo.userRoles) {
      //console.log("go to home")
      if (window.userInfo.userRoles) {
        this.$router.push({ 'name': 'audiences' })// envConfig.defaultPathRedirect })
      } else {
        appApis.loginUser(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid).then(res => {
          userInfo.loading = false
          window.userInfo.userRoles = res.data.roles
          window.userInfo.listOrgs = res.data.list_orgs
          window.userInfo.domain = res.data.domain
          this.$store.dispatch('data-platform/getSelectFields', window.userInfo.domain, null, {root:true})
          this.$router.push({ 'name': 'audiences' })
        })
      }
    }*/
    tasks.lockScreen.lock();
    this.init();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('data-platform', ['setCompanyCode', 'setDefaultLanguage', 'setCompanyName'])), {}, {
    init: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var code;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              code = this.$route.query.code;
              UserSecurityService.loginMicrosoft(code).then(function (response) {
                console.log(response);
                tasks.lockScreen.unlock();
                firebase.auth().signInWithCustomToken(response.data.firebase_token).then(function (result) {
                  _this.getDetailLogin();
                });
              }).catch(function (error) {
                tasks.lockScreen.unlock();
                console.error('Error during Microsoft login:', error);
                _this.$router.push('/ContLogin');
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    submit: function submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.isSignInDisabled = true;
        this.signIn(this.email, this.password);
      }
    },
    signIn: function signIn(email, password) {
      this.$router.push('/');
    },
    onLoginInterbank: function onLoginInterbank() {
      var clientId = "fadb1a8f-d210-4552-acbe-dd570244c004";
      var redirectUri = "http://localhost:8080/auth/microsoft/login";
      var tenant = "e71b62e0-0608-41b7-a9ce-58d7fe8f2bf5";
      var scope = encodeURIComponent("openid profile email User.Read");
      var url = "https://login.microsoftonline.com/".concat(tenant, "/oauth2/v2.0/authorize?client_id=").concat(clientId, "&response_type=code&redirect_uri=").concat(redirectUri, "&scope=").concat(scope);
      window.location.href = url;
    },
    signInProvider: function signInProvider(provider) {},
    resetErrors: function resetErrors() {
      this.error = false;
      this.errorMessages = '';
      this.errorProvider = false;
      this.errorProviderMessages = '';
    },
    onLoginSelect: function () {
      var _onLoginSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(provider) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.current_provider = provider.id;
              if (!(this.current_provider != "email")) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return this.onLogin();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onLoginSelect(_x) {
        return _onLoginSelect.apply(this, arguments);
      }
      return onLoginSelect;
    }(),
    onLogin: function () {
      var _onLogin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var result;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              result = null;
              if (!(this.current_provider == "google")) {
                _context3.n = 2;
                break;
              }
              console.log("google");
              provider = new firebase.auth.GoogleAuthProvider();
              provider.setCustomParameters({
                prompt: 'select_account'
              });
              _context3.n = 1;
              return firebase.auth().signInWithPopup(provider);
            case 1:
              result = _context3.v;
            case 2:
              if (!(this.current_provider == "microsoft")) {
                _context3.n = 4;
                break;
              }
              console.log("google");
              provider = new firebase.auth.OAuthProvider("microsoft.com");
              provider.setCustomParameters({
                prompt: 'select_account'
              });
              _context3.n = 3;
              return firebase.auth().signInWithPopup(provider);
            case 3:
              result = _context3.v;
              _context3.n = 6;
              break;
            case 4:
              if (!(this.current_provider == "email")) {
                _context3.n = 6;
                break;
              }
              _context3.n = 5;
              return firebase.auth().signInWithEmailAndPassword(this.email, this.password);
            case 5:
              result = _context3.v;
            case 6:
              if (result) {
                _context3.n = 7;
                break;
              }
              throw new Error('No se pudo completar la autenticación');
            case 7:
              _context3.n = 8;
              return this.getDetailLogin();
            case 8:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onLogin() {
        return _onLogin.apply(this, arguments);
      }
      return onLogin;
    }(),
    getDetailLogin: function () {
      var _getDetailLogin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this2 = this;
        var service, userLogin, userInfo, user;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              service = UserSecurityService; //result.then(result => {
              userLogin = firebase.auth().currentUser;
              userInfo = window.userInfo || {}; // user info is global var
              window.userInfo = window.userInfo || {};
              userInfo['email'] = userLogin.email ? userLogin.email.toLowerCase() : userLogin.email;
              userInfo['displayName'] = userLogin.displayName;
              userInfo['userLogin'] = userLogin;
              userInfo['accessToken'] = userLogin.xa || userLogin._lat || userLogin.ma;
              userInfo['localId'] = userLogin.uid;
              userInfo['photoURL'] = userLogin.photoURL;
              userInfo['loading'] = window.userInfo.loading;
              userInfo['userRoles'] = window.userInfo.userRoles || null;
              userInfo['listOrgs'] = window.userInfo.listOrgs || null;
              // send login on secondbackground
              user = {
                email: userLogin.email ? userLogin.email.toLowerCase() : userLogin.email,
                uid: userLogin.uid,
                displayName: userLogin.displayName,
                emailVerified: userLogin.emailVerified,
                phoneNumber: userLogin.phoneNumber,
                photoURL: userLogin.photoURL,
                created: userLogin.metadata.creationTime,
                lastSignIn: userLogin.metadata.lastSignInTime
              }; //console.log(user)
              window.userInfo.isSignIn = true;
              window.userInfo.loading = true;
              tasks.lockScreen.lock();
              service.loginUser(userInfo.email, userInfo.accessToken, userInfo.uid, user).then(function (res) {
                tasks.lockScreen.unlock();
                _this2.$store.dispatch('analytic-services/setFlags', res.data.flags);
                _this2.$store.dispatch('data-platform/setFlags', res.data.flags);
                if (_this2.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.LOGIN,
                    eventName: GA_EVENTS.LOGIN,
                    domain: res.data.domain,
                    hash_email: _this2.stringToHash(userInfo.email),
                    type: 'google'
                    // further parameters
                  });
                }
                userInfo.loading = false;
                window.userInfo.userRoles = res.data.roles;
                window.userInfo.listOrgs = res.data.list_orgs;
                window.userInfo.domain = res.data.domain;
                window.userInfo.base_url = res.data.inca_base_url;
                _this2.userInfo = window.userInfo;
                //this.$store.dispatch('data-platform/getLoginDetail')
                UserSecurityService.loginDetail(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid, user).then(function (res2) {
                  window.userInfo.listOrgs = res2.data.list_orgs;
                  window.userInfo.orgs = res2.data.orgs;
                  window.userInfo.photoURL = userLogin.photoURL;
                  window.userInfo.base_url = res2.data.inca_base_url;
                  window.userInfo.somos1_agreement = res2.data.somos1_agreement;
                  _this2.$store.commit('data-platform/setBaseUrl', res2.data.inca_base_url);
                  _this2.$store.commit('data-platform/setDefaultLanguage', res2.data.defaultLanguage);
                  _this2.$store.commit('data-platform/setCompanyCode', res2.data.companyCode);
                  _this2.$store.commit('data-platform/setCompanyName', res2.data.companyName);
                  _this2.$store.commit('data-platform/setOrgs', res2.data.orgs);
                  _this2.$store.commit('data-platform/setMessagingToken', res2.data.messagingToken);
                  _this2.$store.commit('data-platform/setDomainsOptional', res2.data.domains_optional);
                  _this2.setLocale(res2.data.defaultLanguage);
                });
                _this2.$store.dispatch('data-platform/getSelectFields', window.userInfo.domain, null, {
                  root: true
                });
                _this2.$store.dispatch('data-platform/hideInitialSetupMenu', null, {
                  root: true
                });
                _this2.$store.dispatch('data-platform/getIsTableauActive', null, {
                  root: true
                });
                _this2.$store.dispatch('data-platform/getSynapseStatus', window.userInfo.domain, {
                  root: true
                });
                _this2.$store.dispatch('data-platform/getBigqueryStatus', window.userInfo.domain, {
                  root: true
                });
                //this.$store.dispatch('data-platform/getCompanyCode', null, { root: true })
                _this2.$store.dispatch('data-platform/getUserNotifications', userLogin.email, {
                  root: true
                });
                //this.$store.commit('data-platform/setDefaultLanguage', res.data.defaultLanguage)
                //this.$store.commit('data-platform/setOrgs', res.data.orgs)
                //this.$store.commit('data-platform/setMessagingToken', res.data.messagingToken)
                //this.setCompanyCode(res.data.companyCode)
                //this.setCompanyName(res.data.companyName)
                //this.setDefaultLanguage(res.data.defaultLanguage)
                //this.setLocale(res.data.defaultLanguage)
                _this2.$store.dispatch('attribute/getCompanyAbrevs');
                _this2.$store.dispatch('attribute/getLabelCatalog');
                _this2.$store.dispatch('attribute/getStatusLogTypes');
                _this2.$store.dispatch('attribute/getAttributeSourcesCatalog');
                _this2.$store.dispatch('customer-insights/getInitialData');
                _this2.$store.dispatch('audience/getCompanyFlags');
                _this2.$store.dispatch('attribute/getCompanyFlags', res.data.companyCode);
                _this2.$store.dispatch('attribute/getBusinessUserServiceAccounts', res.data.companyCode);
                //console.log('go home')
                _this2.$router.replace({
                  name: 'HomePage'
                });
              });
              // window.userInfo = tasks.getUserInfo()
              // redirecta to root and wait background roles
              // //console.log("go to my tables")
              // self.$router.push({ 'name': "audiences" })//envConfig.defaultPathRedirect })
              // standar response
              //return result
              /*}).catch(e => {
                //console.log(e)
                return e
              })*/
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      function getDetailLogin() {
        return _getDetailLogin.apply(this, arguments);
      }
      return getDetailLogin;
    }()
  })
};